import React, { useState, useEffect } from "react";

import { pageTitle } from "../PageTitle";

import BreadCrumb from "../BreadCrumb";

import HeaderOne from "../Header/HeaderOne";

import FooterOne from "../Footer/FooterOne";

import { Link, useLocation } from "react-router-dom";

import two from "../../assets/images/resource/man.png";
import { Helmet } from "react-helmet-async";
import service from "../../assets/images/resource/Cloudera_AI1.jpg";

import basebg from "../../assets/images/resource/base.png";
import g1 from "../../assets/images/resource/AI_banner.png";
import { launchFireworks } from "./firework";
import { Typewriter } from 'react-simple-typewriter'
import MatrixBackground from './MatrixBackground';
import ParticleNetwork from "./ParticleNetwork";

const AI = () => {
  pageTitle("Cloudera AI Course");
  // launchFireworks();

//   const TypingText = () => (
//   <h2 style={{ color: '#00ff99', fontFamily: 'monospace' }}>
//     <Typewriter
//       words={['Deploying ML Model...', 'Monitoring Drift...', 'Scaling GPUs...']}
//       loop={0}
//       cursor
//       cursorStyle='_'
//       typeSpeed={70}
//       deleteSpeed={50}
//       delaySpeed={1000}
//     />
//   </h2>
// );
  const [showParticles, setShowParticles] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowParticles(false);
    }, 5000); // 5 seconds

    return () => clearTimeout(timer);
  }, []);

  const [formData, setFormData] = useState({
    name: "",

    email: "",

    subject: "",

    phone: "",

    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    console.log("Form submitted:", formData);
    

    setFormData({
      name: "",

      email: "",

      subject: "",

      phone: "",

      message: "",
    });
  };

  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  const servicesData = [
    { id: 1, title: "AI & RPA", slug: "/rpa-training" },
    { id: 2, title: "Python & SQL", slug: "/python" },
    { id: 3, title: "Data Science With Python", slug: "/cloud" },
    {
      id: 4,
      title: "Cloudera Data Engineering",
      slug: "/data-engineering-course",
    },
    { id: 5, title: "Cloudera Machine Learning", slug: "/machine-learning" },
    { id: 6, title: "Cloudera AI", slug: "/AI" },
    { id: 7, title: "Cloudera Data analyst", slug: "/data-analyst" },
  ];

  const courseDetails = [
    {
      number: 1,
      title: "Introduction to MLOps",
      topics: "MLOps (Machine Learning Operations) is all about taking machine-learning models from the lab into the real world—and keeping them running reliably. In this course, you’ll learn the full MLOps lifecycle on CDP: from data ingestion and exploration, to model training, deployment, and continuous monitoring.",
      youtubeShort: "#"
    },
    {
      number: 2,
      title: "Working with Git",
      topics: "In this module, you’ll learn the core concepts of Git and why it’s different from other version control systems. You’ll see how Git fits into everyday coding workflows, how to use platforms like GitHub to host and collaborate on code, and how branching strategies help teams work safely on features in parallel.",
      youtubeShort: "#"
    },
    {
      number: 3,
      title: "CI/CD Concepts",
      topics: "In this module, you’ll learn the core ideas of Continuous Integration (CI) and Continuous Deployment (CD) and how they fit into the DevOps process. You’ll see how CI/CD pipelines automatically build, test, and deploy code, making software releases faster, more reliable, and easier to repeat.",
      youtubeShort: "#"
    },
    {
      number: 4,
      title: "Docker",
      topics: "In this module, you’ll clarify the difference between Docker and containers. While people often use the terms interchangeably, Docker is actually a platform that lets you package and run applications inside containers. You’ll see how Docker Engine manages the full container lifecycle and how Docker’s tools help you efficiently build, deploy, and run containerized applications in a consistent and repeatable way.",
      youtubeShort: "#"
    },
    {
      number: 5,
      title: "Kubernetes",
      topics: "In this module, you’ll get a clear overview of how Kubernetes runs and manages containerized applications at scale. You’ll learn why Kubernetes is important, how its node architecture and Control Plane work together, and how Pods provide an abstraction layer over containers. You’ll also see how Pods communicate with each other, how configuration is managed, and how Kubernetes handles persistent data storage so your applications can keep their data safe and available.",
      youtubeShort: "#"
    },
    {
      number: 6,
      title: "Introduction to Cloudera AI",
      topics: "In this module, you’ll be introduced to Cloudera AI as an end-to-end enterprise AI solution that helps data teams build predictive insights and make data-informed decisions. You’ll see how its open data lakehouse architecture scales across different data formats and runs in both cloud and on-prem environments, giving you flexible, hybrid data services. You’ll also learn how Cloudera AI focuses on trust and control—ensuring data and model integrity so enterprises can safely build, deploy, and govern AI at scale.",
      youtubeShort: "#"
    },
    {
      number: 7,
      title: "Working with Cloudera AI API",
      topics: "In this module, you’ll learn how to work with Cloudera Machine Learning (CML) API v2 to automate and manage your ML workflows. You’ll see how to authenticate using API keys and environment variables, then use both `curl` and the Python client to list, create, run, and delete projects and jobs. You’ll also learn how to deploy and manage models with the Models API, and create and control applications using the Applications API.",
      youtubeShort: "#"
    },
    {
      number: 8,
      title: "AI Registry",
      topics: "In this module, you’ll learn how the AI Registry acts as the central source for models used by Cloudera AI Inference (CAII). You’ll see how to import models from the Model Hub (like NVIDIA NGC and Hugging Face), register trained MLflow models with their experiment metadata, and even bring in arbitrary Hugging Face models (Tech Preview) into a unified registry within your CDP environment.",
      youtubeShort: "#"
    },
    {
      number: 9,
      title: "Experiments in Cloudera AI",
      topics: "In this module, you’ll see how Cloudera Machine Learning (CML) is typically used with multiple workspaces across the same or different CDP environments. You’ll learn how workspaces can be organized by business unit or environment (DEV, QA, PROD), and understand the trade-offs: better isolation and governance on one side, but extra cost and complexity when integrating use cases across workspaces.",
      youtubeShort: "#"
    },
    {
      number: 10,
      title: "MLOps in Cloudera AI",
      topics: "In this module, you’ll learn how MLOps in Cloudera AI helps make machine learning more predictable, repeatable, and reliable. You’ll see how Cloudera’s unified Edge2AI platform provides all the core building blocks for automated, monitored, and reproducible ML workflows that are also secure, open, and version-controlled. You’ll also understand how these capabilities scale across multiple clouds with full auditing, so enterprises can govern ML at scale with confidence.",
      youtubeShort: "#"
    },
    {
      number: 11,
      title: "Monitoring ML Systems",
      topics: "In this module, you’ll learn how to monitor ML systems using Evidently, an open-source tool that tracks model performance and data drift with clear metrics and visualizations. You’ll see how data drift can quietly degrade your model’s accuracy, how to respond by retraining or adjusting features, and how to plug Evidently into CI/CD pipelines so monitoring and validation become a continuous, automated part of your MLOps workflow.",
      youtubeShort: "#"
    },
    {
      number: 12,
      title: "Configuring and Managing AI Workbenches",
      topics: "In this module, you’ll learn how to configure and manage AI workbenches using Cloudera Machine Learning (CML), a CDP service for auto-scaling, self-service data science environments. You’ll see how a CML workbench lets users create projects, run interactive and batch code in Python, R, or Scala, install open-source packages and frameworks, and securely connect to shared data sources—all from a browser-based interface.",
      youtubeShort: "#"
    },
    {
      number: 13,
      title: "Data Access and Lineage",
      topics: " In this module, you’ll learn how Cloudera tools support data access and governance. You’ll see how to use the Data Catalog to search and view data entities, how Apache Ranger enforces access policies to allow or deny data access, and how Apache Atlas shows end-to-end data lineage so you can understand where data comes from and how it’s used.",
      youtubeShort: "#"
    },
    {
      number: 14,
      title: "Data Visualizations in Cloudera AI",
      topics: "In this module, you’ll learn why data visualization is a key part of data science and decision-making. You’ll get familiar with the main concepts in the Cloudera AI Data Visualization application and walk through creating your own interactive dashboard, so you can turn raw data into clear, insightful visual stories.",
      youtubeShort: "#"
    },
    {
      number: 15,
      title: "AMPs and the Workbench",
      topics: "In this module, you’ll learn how to use the CML workbench to run code directly within a session and keep it version-controlled with Git. You’ll see how to build and share simple ML web apps and dashboards with business stakeholders, and how to install and run Applied ML Prototypes (AMPs) as ready-made reference projects to jump-start your own machine learning workflows.",
      youtubeShort: "#"
    },
    {
      number: 16,
      title: "Autoscaling, Performance and GPU Settings",
      topics: "In this module, you’ll learn how CML automatically scales compute resources up and down, and how to provision and manage GPUs at the workspace and user level. You’ll see how to add GPUs to sessions, experiments, and jobs, write hardware-aware code, and understand both the performance benefits and financial impact of using GPUs for your ML workloads.",
      youtubeShort: "#"
    }
  ];


  const renderServices = () => {
    return servicesData.map((service) => (
      <li
        key={service.id}
        className={service.slug === "/Machine-Learning" ? "active" : ""}
      >
        <Link to={service.slug}>{service.title}</Link>
      </li>
    ));
  };

    const getYouTubeVideoId = (url) => {
    const parts = url.split("/");
    let id = parts[parts.length - 1];
    // Remove query parameters if present
    if (id.includes("?")) {
      id = id.split("?")[0];
    }
    return id;
  };
  const featuredYoutubeLink = "#";
  const featuredVideoId = getYouTubeVideoId(featuredYoutubeLink);
  const featuredEmbedUrl = `https://www.youtube.com/embed/${featuredVideoId}`;

  return (
    <>
      <Helmet>
        <title>Cloudera AI Course - Learn ML with CAI</title>
        <meta
          name="description"
          content="Learn machine learning using Cloudera (CAI) platform. This course teaches you how to build, deploy, and manage ML models using CAI."
        />
        <meta
          name="keywords"
          content="Cloudera, Machine Learning, CAI, Data Science, ML Course, Learn Machine Learning"
        />
        <meta
          property="og:title"
          content="Cloudera AI Course - Learn ML with CAI"
        />
        <meta
          property="og:description"
          content="Learn machine learning using Cloudera (CAI) platform. This course teaches you how to build, deploy, and manage ML models using CAI."
        />
        <meta property="og:image" content={service} />
        <meta property="og:url" content="http://siw.sg/machine-learning" />
      </Helmet>
      <HeaderOne />
      {/* <button onClick={launchFireworks} style={{ margin: "20px", padding: "10px" }}>
        Celebrate with Fireworks 🎉
      </button> */}
      {/* <TypingText /> */}
      {/* <MatrixBackground /> */}
      {/* {showParticles && <ParticleNetwork />} */}


      <section className="page__title p_relative">
        <div
          className="bg-layer"
          style={{ backgroundImage: `url(${g1})` }}
        ></div>
        <div className="auto-container">
          <div className="content__box p_relative">
            {/* <ul className="bread__crumb">
                    <li><Link to="/">Home</Link></li>
                    {pathnames.map((name, index) => (
                    <li key={index}>
                        <span> -</span>
                        <Link to={`/${pathnames.slice(0, index + 1).join('/')}`}>{name}</Link>
                    </li>
                    ))}
                </ul> */}
            {/* <h1 className="title">{pathnames.length > 0 ? pathnames[pathnames.length - 1] : 'Home'}</h1> */}
          </div>
        </div>
      </section>

      <div className="service__details p_relative">
        <div className="auto-container">
          <div className="row">
            <div className="col-xl-8 col-lg-12 col-md-12">
              <div className="service__right">
                <figure>
                  <img src={service} alt="Service" />
                </figure>

                <h2>
                  <span>About This Training</span>
                </h2>

                <p>
                  This course presents detailed explanation, comprehensive theory, key skills, and recommended practices for successful platform administration. Upon completion of this course a Cloudera Administrator will learn the full range of functionality and capability of Cloudera Manager.   This course provides an in-depth explanation and skills to become highly productive with Cloudera Manager and the Cloudera platform. Cloudera Manager is a full featured and mature DevOps tool. It is used to install, configure, operate, troubleshoot, report, and upgrade Cloudera. Many Cloudera Administrators only use a fraction of the capabilities built into Cloudera Manager. This course teaches the architecture, deployment, configuration, logging, reporting, REST API, and much more. The course provides references for architecture and recommended practices used by enterprises around the globe.   What to expect While this course is an entry point for aspiring Cloudera Administrators this course is detailed enough for more senior Cloudera Administrators to discover new functionality and capabilities. This course is intended for Linux Administrators who are taking up roles as Platform Administrators. We recommend a minimum of 2 years of system administration experience in industry. Students must have proficiency in Linux. Knowledge of Directory Services, Transport Layer Security, Kerberos, and SQL select statements is helpful. Students must have access to the Internet to reach Amazon Web Services.
                </p>
                <h3>
                  <span>What Skills You Will Gain</span>
                </h3>

                <ul style={{ marginBottom: "15px", lineHeight: "1.0" }}>
                  <li> Utilize Cloudera SDX and other components of the Cloudera platform to locate data for machine learning experiments</li>
                  <li> Use an Cloudera Accelerators for Machine Learning Projects (AMPs)</li>
                  <li> Manage machine learning experiments</li>
                  <li> Connect to various data sources and explore data</li>
                  <li> Deploy an ML model as a REST API</li>
                  <li>Manage and monitor deployed ML models</li>
                </ul>
                <h3>
                  {/* <span>Who Should Take This Course?</span>
                </h3>
                  <p>
                  The course is designed for data scientists who need to understand how to 
                  utilize  Cloudera AI and the Cloudera Data Platform to 
                  achieve faster model development and deliver production machine learning
                  at scale. Data engineers, developers, and solution architects who 
                  collaborate with data scientists will also find this course valuable.
                  </p>

                <h3> */}
                  <span>Course Details</span>
                </h3>
                <ul className="course-details-list" style={{ listStyle: "none", padding: 0 }}>
                  {courseDetails.map((item) => {
                    const videoId = getYouTubeVideoId(item.youtubeShort);
                    const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
                    return (
                      <li
                        key={item.number}
                        className="course-detail-item"
                        style={{
                          display: "flex",
                          alignItems: "start",
                          marginBottom: "20px",
                          background: "#f9f9f9",
                          padding: "15px",
                          borderRadius: "8px",
                        }}
                      >
                        <div style={{ flex: 1, paddingRight: "30px" }}>
                          <h5 style={{ margin: "0 0 10px", fontWeight: "bold" }}>
                            {item.number}. {item.title}
                          </h5>
                          <p style={{ margin: 0 }}>{item.topics}</p>
                        </div>
                        {/* <div
                          className="course-detail-video"
                          style={{ position: "relative", minWidth: "120px", marginLeft: "20px" }}
                        >
                          <a
                            href={item.youtubeShort}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ display: "block", position: "relative" }}
                          >
                            <img
                              src={thumbnailUrl}
                              alt={`Youtube Short for ${item.title}`}
                              style={{ width: "150px", height: "auto", borderRadius: "4px" }}
                            />
                            <div
                              className="play-button"
                              style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                zIndex: 2,
                              }}
                            >
                              <svg
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="#fff"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <polygon points="12,8 24,16 12,24" />
                              </svg>
                            </div>
                          </a>
                        </div> */}
                      </li>
                    );
                  })}
                </ul>

                {/* <h3>
                  <span>Course Details</span>
                </h3> */}

                {/* <ul className="course-details-list">
                  <li>

                      {" "}
                      <b>1. Introduction to CAI- </b>{" "}

                    Overview, CAI Versus CDSW, ML Workspaces,
                    Workspace Roles, Projects and Teams, Settings,
                    Runtimes/Legacy Engines.
                  </li>

                  <li>

                      {" "}
                      <b>2. Introduction to AMPs and the Workbench -</b>{" "}

                     Editors and IDE, Git, Embedded Web
                    Applications, AMPs, Data Access and Lineage.
                  </li>

                  <li>

                      {" "}
                      <b> 3. SDX Overview -</b>{" "}

                   Data Catalog, Authorization, Lineage.
                  </li>

                  <li>

                      {" "}
                      <b> 4. Data Visualization in CAI -</b>{" "}

                     Data Visualization Overview, CDP Data
                    Visualization Concepts, Using Data Visualization in CAI.
                  </li>

                  <li>

                      {" "}
                      <b> 5. Experiments -</b>{" "}

                     Experiments in CAI, Introduction to the
                    CAI Native Workbench.
                  </li>

                  <li>

                      {" "}
                      <b>6. Spark Overview -</b>{" "}

                     How Spark Works, The Spark Stack, File
                    Formats in Spark, Spark Interface Languages, Introduction to
                    PySpark, How Data Frame Operations Become Spark Jobs, How
                    Spark Executes a Job.
                  </li>

                  <li>

                      <b> 7. Running a Spark Application -</b>{" "}

                     Running a Spark Application, Reading data
                    into a Spark SQL Data Frame, Examining the Schema of a Data
                    Frame, Computing the Number of Rows and Columns of a Data
                    Frame, Examining a Few Rows of a Data Frame, Stopping a
                    Spark Application.
                  </li>

                  <li>

                      {" "}
                      <b>8. Inspecting a Spark Data Frame -</b>{" "}
                    Inspecting a Data Frame, Inspecting a Data
                    Frame Column.
                  </li>

                  <li>

                      <b> 9. Transforming Data Frames -</b>{" "}
                   Spark SQL Data Frames, Working with
                    Columns, Working with Rows, Working with Missing Values,
                    Transforming Data Frame Columns.
                  </li>

                  <li>

                      <b>10. Spark SQL Data Types -</b>{" "}
                    Working with Numerical Columns, Working
                    with String Columns, Working with Date and Timestamp
                    Columns, Working with Boolean Columns, Complex Types.
                  </li>

                  <li>

                      <b>11. User-Defined Functions -</b>{" "}
                  Example 1: Hour of Day, Example 2:
                    Great-Circle Distance.
                  </li>

                  <li>

                      <b>12. Reading and Writing Data Frames -</b>{" "}
                     Working with Delimited Text Files, Working
                    with Text Files, Working with Parquet Files, Working with
                    Hive Tables, Working with Object Stores, Working with Pandas
                    Data Frames.
                  </li>

                  <li>

                      <b> 13. Combining and Splitting Data Frames -</b>{" "}
                    Joining Data Frames, Splitting a Data
                    Frame.
                  </li>

                  <li>

                      <b> 14. Summarizing and Grouping Data Frames -</b>{" "}
                     Summarizing Data with Aggregate Functions,
                    Grouping Data, Pivoting Data.
                  </li>

                  <li>
                 
                      {" "}
                      <b> 15. Window Functions -</b>{" "}
               Example: Cumulative Count and Sum,
                    Example: Compute Average Days Between Rides for Each Rider.
                  </li>

                  <li>

                      <b> 16. Machine Learning Overview -</b>{" "}
                   Introduction to Machine Learning, Machine
                    Learning Tools, Apache Spark MLlib.
                  </li>

                  <li>

                      <b> 17. Exploring and Visualizing Data Frames -</b>{" "}
                  Possible Workflows for Big Data, Exploring
                    a Single Variable, Exploring a Pair of Variables.
                  </li>

                  <li>

                      <b>
                        {" "}
                        18. Monitoring, Tuning, and Configuring Spark
                        Applications -
                      </b>{" "}
                    Monitoring Spark Applications, Configuring
                    the Spark Environment.
                  </li>

                  <li>

                      <b> 19. Fitting and Evaluating Regression Models -</b>{" "}
                   Assemble the Feature Vector, Fit the
                    Linear Regression Model.
                  </li>

                  <li>

                      <b>
                        {" "}
                        20. Fitting and Evaluating Classification Models -{" "}
                      </b>{" "}

                    Generate Label, Fit the Logistic
                    Regression Model.
                  </li>

                  <li>

                      <b>
                        {" "}
                        21. Tuning Algorithm Hyperparameters Using Grid Search -{" "}
                      </b>{" "}

                   Requirements for Hyperparameter Tuning,
                    Tune the Hyperparameters Using Holdout Cross-Validation,
                    Tune the Hyperparameters Using K-Fold Cross-Validation.
                  </li>

                  <li>

                      <b> 22. Fitting and Evaluating Clustering Models -</b>{" "}
 Print and Plot the Home Coordinates, Fit a
                    Gaussian Mixture Model, Explore the Cluster Profiles.
                  </li>

                  <li>

                      <b>
                        {" "}
                        23. Processing Text: Fitting and Evaluating Topic Models -{" "}
                      </b>{" "}
                   Fit a Topic Model Using Latent Dirichlet
                    Allocation.
                  </li>

                  <li>

                      <b> 24. Fitting and Evaluating Recommender Models -</b>{" "}
                   Recommender Models, Generate
                    Recommendations.
                  </li>

                  <li>

                      <b> 25. Working with Machine Learning Pipelines - </b>{" "}
                 Fit the Pipeline Model, Inspect the
                    Pipeline Model.
                  </li>

                  <li>

                      <b>
                        {" "}
                        26. Applying a Scikit-Learn Model to a Spark Data Frame -{" "}
                      </b>{" "}
                     Build a Scikit-Learn Model, Apply the
                    Model Using a Spark UDF.
                  </li>

                  <li>

                      <b>
                        {" "}
                        27. Deploying a Machine Learning Model as a REST API in
                        CAI -{" "}
                      </b>{" "}
                    Load the Serialized Model, Define a
                    Wrapper Function to Generate a Prediction, Test the
                    Function.
                  </li>

                  <li>

                      <b>
                        {" "}
                        28. Auto scaling, Performance, and GPU Settings -{" "}
                      </b>{" "}

                    Auto scaling Workloads, Working with GPUs.
                  </li>

                  <li>

                      <b> 29. Model Metrics and Monitoring -</b>{" "}
                    Why Monitor Models?, Common Models
                    Metrics, Models Monitoring With Evidently, Continuous Model
                    Monitoring.
                  </li>

                  <li>

                      <b>30. Appendix: Workspace Provisioning -</b>{" "}
                    Workspace and Environment.
                  </li>
                </ul> */}
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 col-md-12">
              <div className="service__details__left">
                    <iframe
                      width="100%"
                      height="600"
                      src={featuredEmbedUrl}
                      title="Featured YouTube Video"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      style={{ borderRadius: "8px" }}
                    ></iframe>
                <div className="sidebar__widget">
                  <div className="all__service">
                    <h4>All Courses</h4>
                  </div>

                  <ul className="service__details__1__cat">
                    {renderServices()}
                  </ul>
                </div>

                {/* <div
                  className="sidebar__widget_network"
                  style={{ backgroundImage: `url(${basebg})` }}
                >
                  <h3>Contact Us For Any Require</h3>

                  <div className="services__icon">
                    <i className="icon-19"></i>
                  </div>

                  <p>Need help? Call us:</p>

                  <h4>+65 90059743</h4>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <FooterOne />
    </>
  );
};

export default AI;
